/**
 * Generic filtered LU dropdown handler.
 *
 * Watches "source" fields and repopulates dependent ACF select fields whose
 * wrapper carries the following class (set in the ACF admin field wrapper):
 *
 *   lu-filter-{SourceFieldName}
 *
 * The source field name is also used as the LU filter column name (same
 * convention as IMMP). The LU table is resolved server-side via the field key.
 *
 * Example for the County field:
 *   Wrapper class: lu-filter-StateCode
 *
 * When the source field has no value the dependent select is emptied.
 * When the source field already has a value on ACF ready (e.g. from prefill)
 * the options are fetched immediately.
 */
module.exports = function init_lu_filter($) {

  if (!window.acf) return;

  acf.addAction('ready', function () {

    $('.acf-field').each(function () {
      const $wrap = $(this);
      const classes = ($wrap.attr('class') || '').split(/\s+/);

      const filter_cls = classes.find(c => c.startsWith('lu-filter-'));
      const filtercol_cls = classes.find(c => c.startsWith('lu-filtercol-'));
      if (!filter_cls) return;

      // AF converts underscores→hyphens in wrapper classes; convert back.
      const source_name = filter_cls.replace('lu-filter-', '').replace(/-/g, '_');
      // If lu-filtercol-* is present use it, otherwise fall back to source_name.
      const filter_column = filtercol_cls
        ? filtercol_cls.replace('lu-filtercol-', '').replace(/-/g, '_')
        : source_name;
      const field_key = $wrap.data('key');

      const $source_wrap = $(`.acf-field[data-name="${source_name}"]`);
      const $source_select = $source_wrap.find('select');
      const $target_select = $wrap.find('select');

      if (!$source_select.length || !$target_select.length) return;

      function populate(filter_value, preserve_value) {
        $target_select.empty();
        if (!filter_value) {
          $target_select.trigger('change');
          return;
        }
        $.post(mlmp_settings.ajax_url, {
          action: 'get_filtered_lu_options',
          ajax_nonce: mlmp_settings.nonce,
          field_key: field_key,
          filter_column: filter_column,
          filter_value: filter_value,
        }, function (response) {
          if (!response) return;
          $.each(response, function (key, label) {
            $target_select.append($('<option>', { value: key, text: label }));
          });
          if (preserve_value) {
            $target_select.val(preserve_value);
          }
          $target_select.trigger('change');
        });
      }

      $source_select.on('change', function () {
        populate($(this).val());
      });

      // Populate immediately if source already has a value (e.g. prefill).
      // Capture the target's current value first so it can be restored after
      // the options are rebuilt from the AJAX response.
      // Defer one tick so select2 has time to reflect the prefilled value.
      setTimeout(function () {
        const initial_val = $source_select.val();
        if (initial_val) {
          const existing_val = $target_select.val();
          populate(initial_val, existing_val);
        }
      }, 0);
    });

  });

};
